import React, { forwardRef } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { createCSSTransition } from '@polestar/component-warehouse-react/tokens/motion/Motion';
import { shouldNotForwardProps } from '@polestar/component-warehouse-react/helpers/shouldForwardProps';
import { reduceAnimation } from '@polestar/component-warehouse-react/helpers/accessibility';
import { useDirection } from '@polestar/component-warehouse-react/contexts/direction';
const Skeleton = forwardRef(({ height, width = '100%', ...props }, ref) => {
    const { isRTL } = useDirection();
    return React.createElement(StyledSkeleton, { ref: ref, width: width, height: height, ...props, rtl: isRTL });
});
Skeleton.displayName = 'Skeleton';
export default Skeleton;
// defining 2 keyframe-animations is needed to ensure that when you swap RTl to LTR
// the animation does not use its current position as its reference points
// but resets itself to the correct start position
const StyledSkeleton = styled('div', shouldNotForwardProps(false, 'width', 'height', 'rtl'))(({ theme: { skeleton: { backgroundColor, highlightColor }, }, width = '100%', height = '100%', rtl, }) => css `
    position: relative;
    background: ${backgroundColor};
    overflow: hidden;
    height: ${height};
    width: ${width};

    &:after {
      content: '';
      position: absolute;
      z-index: 1;
      inset-block-start: 0;
      inset-inline-start: 0;
      inset-block-end: 0;
      width: 500%;
      min-width: 320px;
      background: linear-gradient(
          to right,
          ${backgroundColor} ${rtl ? 100 : 0}%,
          ${highlightColor} 25%,
          ${backgroundColor} 50%,
          ${highlightColor} 75%,
          ${backgroundColor} 100%
        )
        50% 50%;
      animation: ${createCSSTransition(rtl ? 'reversedPulse' : 'pulse', 'linear', 2000)} infinite;
      ${reduceAnimation()};
    }

    @keyframes reversedPulse {
      0% {
        transform: translate3d(50%, 0, 0);
      }
      100% {
        transform: translate3d(0%, 0, 0);
      }
    }

    @keyframes pulse {
      0% {
        transform: translate3d(-50%, 0, 0);
      }
      100% {
        transform: translate3d(0%, 0, 0);
      }
    }
  `);
